import { LoadingButton } from "@mui/lab";
import { Box, Stack, Typography } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import SearchForm from "components/SearchForm";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocationAdminThunk } from "store/reducers/accounts";
import {
  assignLocationAdminToLocationThunk,
  getLocationsThunk,
  locationSelector,
  removeLocationAdminToLocationThunk,
} from "store/reducers/inventory/locationSlice";

const AssignLocationAdminToLocationDialog = ({
  open,
  handleClose,
  location_id,
}) => {
  const [search, setSearch] = React.useState("");
  const dispatch = useDispatch();
  const locationAdmins = useSelector((state) => state.accounts.locationAdmins);
  useEffect(() => {
    console.log({ search });
  }, [search]);

  const { loading } = useSelector((state) => state.location);

  const location = useSelector(locationSelector.selectAll).find(
    (item) => item.id === location_id
  );

  useEffect(() => {
    dispatch(getLocationsThunk());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getLocationAdminThunk());
  }, [dispatch]);

  const assignLocationAdmin = (locationAdmin) => {
    dispatch(
      assignLocationAdminToLocationThunk({
        location: location.id,
        location_admin: locationAdmin,
      })
    );
  };

  const removeLocationAdmin = (locationAdmin) => {
    dispatch(
      removeLocationAdminToLocationThunk({
        location: location.id,
        location_admin: locationAdmin.id,
      })
    );
  };

  return (
    <CustomDialog
      fullScreen={false}
      open={open}
      handleClose={()=>{handleClose(false)}}
      heading="Select location admin to assign"
    >
      <Box paddingX={2}>
        <SearchForm
          hint="Search locations"
          submitSearch={setSearch}
          sx={{ marginY: 2 }}
        />
      </Box>
      {locationAdmins.length > 0 ? (
        <>
          {locationAdmins
            .filter((item) =>
              item.profile.first_name.toLowerCase().includes(search.toLowerCase())
            )
            .map((locationAdmin) => (
              <Stack
                justifyContent="space-between"
                margin={2}
                direction="row"
                alignItems="center"
                key={locationAdmin.id}
              >
                <Typography variant="body1">
                  {locationAdmin.profile.first_name} {locationAdmin.profile.last_name}
                </Typography>
                {location?.location_admin?.id === locationAdmin.profile.id ? (
                  <LoadingButton
                    variant="outlined"
                    size="small"
                    loading={loading?.removeAdmin === locationAdmin.profile.id}
                    onClick={() => removeLocationAdmin(locationAdmin.profile)}
                    color="error"
                  >
                    Remove
                  </LoadingButton>
                ) : (
                  <LoadingButton
                    variant="outlined"
                    size="small"
                    loading={loading?.assignAdmin === locationAdmin.profile.id}
                    onClick={() => assignLocationAdmin(locationAdmin.profile)}
                  >
                    Assign
                  </LoadingButton>
                )}
              </Stack>
            ))}
        </>
      ) : (
        <Typography textAlign="center"> No items </Typography>
      )}
    </CustomDialog>
  );
};

export default AssignLocationAdminToLocationDialog;
